export const ISO_DATE_FORMAT = "MM/dd/yyyy";

export const DEFAULT_FILTERS = {
  waterSource: 4,
};
